var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 13.5C15.5637 13.5 18.25 10.8137 18.25 7.5C18.25 4.18629 15.5637 1.5 12.25 1.5C8.9363 1.5 6.25 4.18629 6.25 7.5C6.25 10.8137 8.9363 13.5 12.25 13.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24L26.5 28.5M26.5 28.5L31 24M26.5 28.5V19.5M21.25 1.93614C23.4489 2.82622 25 4.98197 25 7.5C25 10.018 23.4489 12.1738 21.25 13.0639M16 19.5H10C7.20435 19.5 5.80653 19.5 4.7039 19.9567C3.23373 20.5657 2.06569 21.7337 1.45673 23.2039C1 24.3065 1 25.7044 1 28.5M18.25 7.5C18.25 10.8137 15.5637 13.5 12.25 13.5C8.9363 13.5 6.25 10.8137 6.25 7.5C6.25 4.18629 8.9363 1.5 12.25 1.5C15.5637 1.5 18.25 4.18629 18.25 7.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.629aeaa7.svg";
export { ForwardRef as ReactComponent };